import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const SipIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"sip"} ref={ref}/>
});

SipIcon.displayName = "SipIcon";
